import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import Billing from "@/pages/Billing";

export const Route = createFileRoute("/cuenta/facturacion")({
  head: () => ({
    meta: [
      { title: "Mi suscripción | Retail Lemon" },
      { name: "description", content: "Gestiona tu plan, tus extras y la mentoría de Retail Lemon." },
      { property: "og:title", content: "Mi suscripción | Retail Lemon" },
      { property: "og:description", content: "Gestiona tu plan, tus extras y la mentoría de Retail Lemon." },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => (
    <ProtectedRoute>
      <Billing />
    </ProtectedRoute>
  ),
});
